import { render, staticRenderFns } from "./AppComponentsDialog.vue?vue&type=template&id=36a9e198&scoped=true"
import script from "./AppComponentsDialog.vue?vue&type=script&lang=js"
export * from "./AppComponentsDialog.vue?vue&type=script&lang=js"
import style0 from "./AppComponentsDialog.vue?vue&type=style&index=0&id=36a9e198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a9e198",
  null
  
)

export default component.exports